import * as React from 'react';
import { AlertIcon } from '../AlertIcon/AlertIcon';
import { CloseIcon } from './CloseIcon/CloseIcon';
import { usePrevious } from '../../utils/hooks/usePrevious';


export var Toast = React.memo(function (props) {
    var title = props.title, message = props.message, _a = props.type, type = _a === void 0 ? 'info' : _a, direction = props.direction, className = props.className, open = props.open, onClose = props.onClose, duration = props.duration;
    var initialOpen = open !== undefined ? open : true;
    var _b = React.useState(initialOpen), currentOpen = _b[0], setCurrentOpen = _b[1];
    var handleCloseClick = React.useCallback(function () {
        if (onClose) {
            // controlled -> let the parent handle the open state
            onClose();
            return;
        }
        // uncontrolled -> handle internal open state
        setCurrentOpen(false);
    }, [currentOpen, onClose]);
    var previousOpen = usePrevious(currentOpen);
    var isClosing = previousOpen && !currentOpen;
    // handle 'open' prop
    React.useEffect(function () {
        if (open === undefined) {
            // uncontrolled -> nothing to do
            return;
        }
        if (open !== currentOpen) {
            // controlled -> open prop changed, update state
            setCurrentOpen(open);
        }
    }, [open, currentOpen]);
    // handle 'duration' prop
    var closeTimeout = React.useRef();
    React.useEffect(function () {
        // check if window is defined to prevent from breaking in SSR
        if (typeof window === 'undefined') {
            return;
        }
        // set close timeout if 'duration' is defined
        if (duration === undefined) {
            return;
        }
        if (closeTimeout.current) {
            return;
        }
        closeTimeout.current = window.setTimeout(function () {
            if (onClose) {
                // controlled -> onClose callback
                onClose();
                return;
            }
            // uncontrolled -> update internal state
            if (currentOpen) {
                setCurrentOpen(false);
            }
        }, duration);
        return function () { return clearTimeout(closeTimeout.current); };
    }, [duration, onClose, currentOpen]);
    var toastClassName = "pluggy toast " + (isClosing ? 'closing' : '') + " " + type + " " + (currentOpen ? 'visible' : '') + " " + (direction || '') + " " + (className ? className : '');
    return (React.createElement("div", { className: toastClassName },
        React.createElement(CloseIcon, { onClick: handleCloseClick, className: "close-icon-wrapper" }),
        React.createElement("div", { className: "indicator" }),
        React.createElement(AlertIcon, { name: type, className: "alert-icon" }),
        React.createElement("div", { className: "text-wrapper" },
            React.createElement("div", { className: "title" }, title),
            React.createElement("div", { className: "text" }, message))));
});
